import React from 'react';
import {
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';

import Button from 'shared/modules/common/components/atoms/Button';
import CheckBox from 'shared/modules/common/components/atoms/CheckBox';
import generateID from 'shared/modules/common/utils/generate-id';

type Data = {
  agreementAccepted: boolean;
};

type Props = {
  onNextButtonPress?: () => void;
  data?: Data;
  onDataUpdate?: (data: Data) => void;
};

const AutoDebitRegistrationTerms = (props: Props) => {
  const onChange = (checked: boolean) => {
    props.onDataUpdate?.({
      agreementAccepted: checked,
    });
  };

  return (
    <View style={style.root}>
      <Text style={style.textTitle}>注意事項</Text>
      <ScrollView
        style={style.scrollView}
        /** Generate HTML and Test IDs  */
        {...generateID('adr-terms-scrollview')}
      >
        <Text>
          最短で口座振替申し込み月の翌月から引き落としが可能です。
          {'\n\n'}
          口座振替が可能かどうかは、MyPaidy、または請求のご案内で確認できます。
          {'\n\n'}
          最後の画面で「収納機関へ通知」ボタンを必ずクリックしてください。
          {'\n\n'}
          クリックしないと、手続きは完了しません。
          {'\n\n'}
          お申込手続きには20分の時間制限があります。
          {'\n\n'}
          お申し込み内容が反映されるまで2〜3日かかる場合があります。
          {'\n\n'}
          口座振替等の登録手続きが、毎月末日までに完了した場合、原則として翌月請求分以降が口座振替となります。みずほ銀行をご利用のお客様は、20日までにご登録が完了した場合は翌月、21日以降のご登録の場合は翌々月から引き落としが開始されます。なお、前述の場合でも、収納代行会社の手続き上、当社が請求書を発行するまでに登録が完了されない場合がございます。当月のお支払い方法（口座振替またはコンビニ・銀行振込）につきましては、MyPaidyあるいは毎月１日から３日に送信される請求の案内メールをご確認ください。
          {'\n\n'}
          引き落とし日は毎月12日（金融機関の休業日の場合は翌営業日）です。
          {'\n\n'}
          1月及び5月請求分の引き落とし日は20日（金融機関の休業日の場合は翌営業日）になる場合がございます。
          1日から3日の間に請求金額と引き落とし日の案内をメールとSMSで通知いたしますので、そちらでご確認ください。
          {'\n\n'}
          ご利用可能な金融機関をご確認の上、お申し込みください。
          {'\n\n'}
          提携金融機関の動作環境により、利用できない場合があります。
          予めご了承ください。
          {'\n\n'}
          各金融機関の実施するメンテナンス時間帯はご利用できない場合があります。予めご了承ください。
          {'\n\n'}
          口座振替日に引き落としができなかった場合、コンビニまたは銀行振込でのお支払いとなります。
          その場合、引き落とし日の3〜4営業日後にご利用のメールアドレスにお支払いのご案内をお送りいたします。
          また、コンビニでお支払いの場合は、弊社指定の手数料が発生いたします。
          銀行振込の場合は、各金融機関の指定する振込手数料を別途ご負担いただきます。
        </Text>
      </ScrollView>
      <TouchableOpacity
        style={style.checkBoxWrapper}
        onPress={() => onChange(!props.data?.agreementAccepted)}
      >
        <CheckBox
          checked={props.data?.agreementAccepted}
          onChange={onChange}
          style={style.checkBox}
          id="adr-agreement-accept-field"
        />
        <Text
          /** Generate HTML and Test IDs  */
          {...generateID('adr-agreement-accept-label')}
        >
          注意事項に同意します
        </Text>
      </TouchableOpacity>
      <Button
        title="口座振替に申込む"
        onPress={() => props.onNextButtonPress?.()}
        disabled={!props.data?.agreementAccepted}
        id="adr-next-button"
        style={style.button}
      />
    </View>
  );
};

const style = StyleSheet.create({
  root: {
    flex: 1,
  },
  textTitle: {
    fontWeight: 'bold',
    fontSize: 24,
    marginBottom: 32,
  },
  scrollView: {
    flexGrow: 1,
    marginBottom: 24,
  },
  checkBoxWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 24,
  },
  checkBox: {
    marginRight: 16,
  },
  button: {
    alignSelf: 'center',
    maxWidth: 296,
  },
});

export default AutoDebitRegistrationTerms;
